var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lets-icons:return"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.32031 14.5L3.61331 13.793L2.90631 14.5L3.61331 15.207L4.32031 14.5ZM21.3203 6.50003C21.3203 6.23481 21.215 5.98046 21.0274 5.79292C20.8399 5.60539 20.5855 5.50003 20.3203 5.50003C20.0551 5.50003 19.8007 5.60539 19.6132 5.79292C19.4257 5.98046 19.3203 6.23481 19.3203 6.50003H21.3203ZM8.61331 8.79303L3.61331 13.793L5.02731 15.207L10.0273 10.207L8.61331 8.79303ZM3.61331 15.207L8.61331 20.207L10.0273 18.793L5.02731 13.793L3.61331 15.207ZM4.32031 15.5L14.3203 15.5V13.5L4.32031 13.5V15.5ZM21.3203 8.50003V6.50003H19.3203V8.50003H21.3203ZM14.3203 15.5C16.1768 15.5 17.9573 14.7625 19.2701 13.4498C20.5828 12.137 21.3203 10.3565 21.3203 8.50003H19.3203C19.3203 9.82611 18.7935 11.0979 17.8558 12.0356C16.9182 12.9732 15.6464 13.5 14.3203 13.5V15.5Z",
    fill: "url(#paint0_linear_723_2368)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_723_2368",
    x1: 12.1133,
    y1: 20.207,
    x2: 12.1133,
    y2: 5.50003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.b80079b2bcabcd68edc2f141b80c86ce.svg";
export { ForwardRef as ReactComponent };